var re = Object.defineProperty;
var ie = (a, s, r) => s in a ? re(a, s, { enumerable: !0, configurable: !0, writable: !0, value: r }) : a[s] = r;
var J = (a, s, r) => ie(a, typeof s != "symbol" ? s + "" : s, r);
import { c as oe, B as S, b as d, a as E, P as ae, g as ue } from "../../js.cookie-B8VfNCgS.js";
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var ce = /* @__PURE__ */ function() {
  function a(r) {
    var e = r || {}, n = e.ValidationData, t = e.Username, i = e.Password, o = e.AuthParameters, u = e.ClientMetadata;
    this.validationData = n || {}, this.authParameters = o || {}, this.clientMetadata = u || {}, this.username = t, this.password = i;
  }
  var s = a.prototype;
  return s.getUsername = function() {
    return this.username;
  }, s.getPassword = function() {
    return this.password;
  }, s.getValidationData = function() {
    return this.validationData;
  }, s.getAuthParameters = function() {
    return this.authParameters;
  }, s.getClientMetadata = function() {
    return this.clientMetadata;
  }, a;
}();
function he(a) {
  for (var s = a.words, r = a.sigBytes, e = [], n = 0; n < r; n++) {
    var t = s[n >>> 2] >>> 24 - n % 4 * 8 & 255;
    e.push((t >>> 4).toString(16)), e.push((t & 15).toString(16));
  }
  return e.join("");
}
var fe = /* @__PURE__ */ function() {
  function a(r, e) {
    r = this.words = r || [], e != null ? this.sigBytes = e : this.sigBytes = r.length * 4;
  }
  var s = a.prototype;
  return s.random = function(e) {
    for (var n = [], t = 0; t < e; t += 4)
      n.push(oe());
    return new a(n, e);
  }, s.toString = function() {
    return he(this);
  }, a;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
function B(a) {
  return d.Buffer.from(new fe().random(a).toString(), "hex");
}
var le = /^[89a-f]/i, ge = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF", de = "userAttributes.", I = /* @__PURE__ */ function() {
  function a(r) {
    this.N = new S(ge, 16), this.g = new S("2", 16), this.k = new S(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16), this.smallAValue = this.generateRandomSmallA(), this.getLargeAValue(function() {
    }), this.infoBits = d.Buffer.from("Caldera Derived Key", "utf8"), this.poolName = r;
  }
  var s = a.prototype;
  return s.getSmallAValue = function() {
    return this.smallAValue;
  }, s.getLargeAValue = function(e) {
    var n = this;
    this.largeAValue ? e(null, this.largeAValue) : this.calculateA(this.smallAValue, function(t, i) {
      t && e(t, null), n.largeAValue = i, e(null, n.largeAValue);
    });
  }, s.generateRandomSmallA = function() {
    var e = B(128).toString("hex"), n = new S(e, 16);
    return n;
  }, s.generateRandomString = function() {
    return B(40).toString("base64");
  }, s.getRandomPassword = function() {
    return this.randomPassword;
  }, s.getSaltDevices = function() {
    return this.SaltToHashDevices;
  }, s.getVerifierDevices = function() {
    return this.verifierDevices;
  }, s.generateHashDevice = function(e, n, t) {
    var i = this;
    this.randomPassword = this.generateRandomString();
    var o = "" + e + n + ":" + this.randomPassword, u = this.hash(o), c = B(16).toString("hex");
    this.SaltToHashDevices = this.padHex(new S(c, 16)), this.g.modPow(new S(this.hexHash(this.SaltToHashDevices + u), 16), this.N, function(h, f) {
      h && t(h, null), i.verifierDevices = i.padHex(f), t(null, null);
    });
  }, s.calculateA = function(e, n) {
    var t = this;
    this.g.modPow(e, this.N, function(i, o) {
      i && n(i, null), o.mod(t.N).equals(S.ZERO) && n(new Error("Illegal paramater. A mod N cannot be 0."), null), n(null, o);
    });
  }, s.calculateU = function(e, n) {
    this.UHexHash = this.hexHash(this.padHex(e) + this.padHex(n));
    var t = new S(this.UHexHash, 16);
    return t;
  }, s.hash = function(e) {
    var n = new E.Sha256();
    n.update(e);
    var t = n.digestSync(), i = d.Buffer.from(t).toString("hex");
    return new Array(64 - i.length).join("0") + i;
  }, s.hexHash = function(e) {
    return this.hash(d.Buffer.from(e, "hex"));
  }, s.computehkdf = function(e, n) {
    var t = d.Buffer.concat([this.infoBits, d.Buffer.from("", "utf8")]), i = new E.Sha256(n);
    i.update(e);
    var o = i.digestSync(), u = new E.Sha256(o);
    u.update(t);
    var c = u.digestSync(), h = c, f = h.slice(0, 16);
    return f;
  }, s.getPasswordAuthenticationKey = function(e, n, t, i, o) {
    var u = this;
    if (t.mod(this.N).equals(S.ZERO))
      throw new Error("B cannot be zero.");
    if (this.UValue = this.calculateU(this.largeAValue, t), this.UValue.equals(S.ZERO))
      throw new Error("U cannot be zero.");
    var c = "" + this.poolName + e + ":" + n, h = this.hash(c), f = new S(this.hexHash(this.padHex(i) + h), 16);
    this.calculateS(f, t, function(l, v) {
      l && o(l, null);
      var g = u.computehkdf(d.Buffer.from(u.padHex(v), "hex"), d.Buffer.from(u.padHex(u.UValue), "hex"));
      o(null, g);
    });
  }, s.calculateS = function(e, n, t) {
    var i = this;
    this.g.modPow(e, this.N, function(o, u) {
      o && t(o, null);
      var c = n.subtract(i.k.multiply(u));
      c.modPow(i.smallAValue.add(i.UValue.multiply(e)), i.N, function(h, f) {
        h && t(h, null), t(null, f.mod(i.N));
      });
    });
  }, s.getNewPasswordRequiredChallengeUserAttributePrefix = function() {
    return de;
  }, s.padHex = function(e) {
    if (!(e instanceof S))
      throw new Error("Not a BigInteger");
    var n = e.compareTo(S.ZERO) < 0, t = e.abs().toString(16);
    if (t = t.length % 2 !== 0 ? "0" + t : t, t = le.test(t) ? "00" + t : t, n) {
      var i = t.split("").map(function(u) {
        var c = ~parseInt(u, 16) & 15;
        return "0123456789ABCDEF".charAt(c);
      }).join(""), o = new S(i, 16).add(S.ONE);
      t = o.toString(16), t.toUpperCase().startsWith("FF8") && (t = t.substring(2));
    }
    return t;
  }, a;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Z = /* @__PURE__ */ function() {
  function a(r) {
    this.jwtToken = r || "", this.payload = this.decodePayload();
  }
  var s = a.prototype;
  return s.getJwtToken = function() {
    return this.jwtToken;
  }, s.getExpiration = function() {
    return this.payload.exp;
  }, s.getIssuedAt = function() {
    return this.payload.iat;
  }, s.decodePayload = function() {
    var e = this.jwtToken.split(".")[1];
    try {
      return JSON.parse(d.Buffer.from(e, "base64").toString("utf8"));
    } catch {
      return {};
    }
  }, a;
}();
function ve(a, s) {
  a.prototype = Object.create(s.prototype), a.prototype.constructor = a, q(a, s);
}
function q(a, s) {
  return q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, e) {
    return r.__proto__ = e, r;
  }, q(a, s);
}
var G = /* @__PURE__ */ function(a) {
  function s(r) {
    var e = r === void 0 ? {} : r, n = e.AccessToken;
    return a.call(this, n || "") || this;
  }
  return ve(s, a), s;
}(Z);
function Se(a, s) {
  a.prototype = Object.create(s.prototype), a.prototype.constructor = a, H(a, s);
}
function H(a, s) {
  return H = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, e) {
    return r.__proto__ = e, r;
  }, H(a, s);
}
var b = /* @__PURE__ */ function(a) {
  function s(r) {
    var e = r === void 0 ? {} : r, n = e.IdToken;
    return a.call(this, n || "") || this;
  }
  return Se(s, a), s;
}(Z);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var z = /* @__PURE__ */ function() {
  function a(r) {
    var e = r === void 0 ? {} : r, n = e.RefreshToken;
    this.token = n || "";
  }
  var s = a.prototype;
  return s.getToken = function() {
    return this.token;
  }, a;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Y = /* @__PURE__ */ function() {
  function a(r) {
    var e = r === void 0 ? {} : r, n = e.IdToken, t = e.RefreshToken, i = e.AccessToken, o = e.ClockDrift;
    if (i == null || n == null)
      throw new Error("Id token and Access Token must be present.");
    this.idToken = n, this.refreshToken = t, this.accessToken = i, this.clockDrift = o === void 0 ? this.calculateClockDrift() : o;
  }
  var s = a.prototype;
  return s.getIdToken = function() {
    return this.idToken;
  }, s.getRefreshToken = function() {
    return this.refreshToken;
  }, s.getAccessToken = function() {
    return this.accessToken;
  }, s.getClockDrift = function() {
    return this.clockDrift;
  }, s.calculateClockDrift = function() {
    var e = Math.floor(/* @__PURE__ */ new Date() / 1e3), n = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
    return e - n;
  }, s.isValid = function() {
    var e = Math.floor(/* @__PURE__ */ new Date() / 1e3), n = e - this.clockDrift;
    return n < this.accessToken.getExpiration() && n < this.idToken.getExpiration();
  }, a;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Ce = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Ue = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], X = /* @__PURE__ */ function() {
  function a() {
  }
  var s = a.prototype;
  return s.getNowString = function() {
    var e = /* @__PURE__ */ new Date(), n = Ue[e.getUTCDay()], t = Ce[e.getUTCMonth()], i = e.getUTCDate(), o = e.getUTCHours();
    o < 10 && (o = "0" + o);
    var u = e.getUTCMinutes();
    u < 10 && (u = "0" + u);
    var c = e.getUTCSeconds();
    c < 10 && (c = "0" + c);
    var h = e.getUTCFullYear(), f = n + " " + t + " " + i + " " + o + ":" + u + ":" + c + " UTC " + h;
    return f;
  }, a;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Q = /* @__PURE__ */ function() {
  function a(r) {
    var e = r === void 0 ? {} : r, n = e.Name, t = e.Value;
    this.Name = n || "", this.Value = t || "";
  }
  var s = a.prototype;
  return s.getValue = function() {
    return this.Value;
  }, s.setValue = function(e) {
    return this.Value = e, this;
  }, s.getName = function() {
    return this.Name;
  }, s.setName = function(e) {
    return this.Name = e, this;
  }, s.toString = function() {
    return JSON.stringify(this);
  }, s.toJSON = function() {
    return {
      Name: this.Name,
      Value: this.Value
    };
  }, a;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var y = {}, me = /* @__PURE__ */ function() {
  function a() {
  }
  return a.setItem = function(r, e) {
    return y[r] = e, y[r];
  }, a.getItem = function(r) {
    return Object.prototype.hasOwnProperty.call(y, r) ? y[r] : void 0;
  }, a.removeItem = function(r) {
    return delete y[r];
  }, a.clear = function() {
    return y = {}, y;
  }, a;
}(), ee = /* @__PURE__ */ function() {
  function a() {
    try {
      this.storageWindow = window.localStorage, this.storageWindow.setItem("aws.cognito.test-ls", 1), this.storageWindow.removeItem("aws.cognito.test-ls");
    } catch {
      this.storageWindow = me;
    }
  }
  var s = a.prototype;
  return s.getStorage = function() {
    return this.storageWindow;
  }, a;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Ae = typeof navigator < "u", $ = Ae ? ae.isReactNative ? "react-native" : navigator.userAgent : "nodejs", D = /* @__PURE__ */ function() {
  function a(r) {
    if (r == null || r.Username == null || r.Pool == null)
      throw new Error("Username and Pool information are required.");
    this.username = r.Username || "", this.pool = r.Pool, this.Session = null, this.client = r.Pool.client, this.signInUserSession = null, this.authenticationFlowType = "USER_SRP_AUTH", this.storage = r.Storage || new ee().getStorage(), this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId(), this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
  }
  var s = a.prototype;
  return s.setSignInUserSession = function(e) {
    this.clearCachedUserData(), this.signInUserSession = e, this.cacheTokens();
  }, s.getSignInUserSession = function() {
    return this.signInUserSession;
  }, s.getUsername = function() {
    return this.username;
  }, s.getAuthenticationFlowType = function() {
    return this.authenticationFlowType;
  }, s.setAuthenticationFlowType = function(e) {
    this.authenticationFlowType = e;
  }, s.initiateAuth = function(e, n) {
    var t = this, i = e.getAuthParameters();
    i.USERNAME = this.username;
    var o = Object.keys(e.getValidationData()).length !== 0 ? e.getValidationData() : e.getClientMetadata(), u = {
      AuthFlow: "CUSTOM_AUTH",
      ClientId: this.pool.getClientId(),
      AuthParameters: i,
      ClientMetadata: o
    };
    this.getUserContextData() && (u.UserContextData = this.getUserContextData()), this.client.request("InitiateAuth", u, function(c, h) {
      if (c)
        return n.onFailure(c);
      var f = h.ChallengeName, l = h.ChallengeParameters;
      return f === "CUSTOM_CHALLENGE" ? (t.Session = h.Session, n.customChallenge(l)) : (t.signInUserSession = t.getCognitoUserSession(h.AuthenticationResult), t.cacheTokens(), n.onSuccess(t.signInUserSession));
    });
  }, s.authenticateUser = function(e, n) {
    return this.authenticationFlowType === "USER_PASSWORD_AUTH" ? this.authenticateUserPlainUsernamePassword(e, n) : this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH" ? this.authenticateUserDefaultAuth(e, n) : n.onFailure(new Error("Authentication flow type is invalid."));
  }, s.authenticateUserDefaultAuth = function(e, n) {
    var t = this, i = new I(this.pool.getUserPoolName()), o = new X(), u, c, h = {};
    this.deviceKey != null && (h.DEVICE_KEY = this.deviceKey), h.USERNAME = this.username, i.getLargeAValue(function(f, l) {
      f && n.onFailure(f), h.SRP_A = l.toString(16), t.authenticationFlowType === "CUSTOM_AUTH" && (h.CHALLENGE_NAME = "SRP_A");
      var v = Object.keys(e.getValidationData()).length !== 0 ? e.getValidationData() : e.getClientMetadata(), g = {
        AuthFlow: t.authenticationFlowType,
        ClientId: t.pool.getClientId(),
        AuthParameters: h,
        ClientMetadata: v
      };
      t.getUserContextData(t.username) && (g.UserContextData = t.getUserContextData(t.username)), t.client.request("InitiateAuth", g, function(C, m) {
        if (C)
          return n.onFailure(C);
        var U = m.ChallengeParameters;
        t.username = U.USER_ID_FOR_SRP, t.userDataKey = t.keyPrefix + "." + t.username + ".userData", u = new S(U.SRP_B, 16), c = new S(U.SALT, 16), t.getCachedDeviceKeyAndPassword(), i.getPasswordAuthenticationKey(t.username, e.getPassword(), u, c, function(A, F) {
          A && n.onFailure(A);
          var R = o.getNowString(), _ = d.Buffer.concat([d.Buffer.from(t.pool.getUserPoolName(), "utf8"), d.Buffer.from(t.username, "utf8"), d.Buffer.from(U.SECRET_BLOCK, "base64"), d.Buffer.from(R, "utf8")]), N = new E.Sha256(F);
          N.update(_);
          var O = N.digestSync(), w = d.Buffer.from(O).toString("base64"), p = {};
          p.USERNAME = t.username, p.PASSWORD_CLAIM_SECRET_BLOCK = U.SECRET_BLOCK, p.TIMESTAMP = R, p.PASSWORD_CLAIM_SIGNATURE = w, t.deviceKey != null && (p.DEVICE_KEY = t.deviceKey);
          var T = function(x, W) {
            return t.client.request("RespondToAuthChallenge", x, function(M, se) {
              return M && M.code === "ResourceNotFoundException" && M.message.toLowerCase().indexOf("device") !== -1 ? (p.DEVICE_KEY = null, t.deviceKey = null, t.randomPassword = null, t.deviceGroupKey = null, t.clearCachedDeviceKeyAndPassword(), T(x, W)) : W(M, se);
            });
          }, K = {
            ChallengeName: "PASSWORD_VERIFIER",
            ClientId: t.pool.getClientId(),
            ChallengeResponses: p,
            Session: m.Session,
            ClientMetadata: v
          };
          t.getUserContextData() && (K.UserContextData = t.getUserContextData()), T(K, function(V, x) {
            return V ? n.onFailure(V) : t.authenticateUserInternal(x, i, n);
          });
        });
      });
    });
  }, s.authenticateUserPlainUsernamePassword = function(e, n) {
    var t = this, i = {};
    if (i.USERNAME = this.username, i.PASSWORD = e.getPassword(), !i.PASSWORD) {
      n.onFailure(new Error("PASSWORD parameter is required"));
      return;
    }
    var o = new I(this.pool.getUserPoolName());
    this.getCachedDeviceKeyAndPassword(), this.deviceKey != null && (i.DEVICE_KEY = this.deviceKey);
    var u = Object.keys(e.getValidationData()).length !== 0 ? e.getValidationData() : e.getClientMetadata(), c = {
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: this.pool.getClientId(),
      AuthParameters: i,
      ClientMetadata: u
    };
    this.getUserContextData(this.username) && (c.UserContextData = this.getUserContextData(this.username)), this.client.request("InitiateAuth", c, function(h, f) {
      return h ? n.onFailure(h) : t.authenticateUserInternal(f, o, n);
    });
  }, s.authenticateUserInternal = function(e, n, t) {
    var i = this, o = e.ChallengeName, u = e.ChallengeParameters;
    if (o === "SMS_MFA")
      return this.Session = e.Session, t.mfaRequired(o, u);
    if (o === "SELECT_MFA_TYPE")
      return this.Session = e.Session, t.selectMFAType(o, u);
    if (o === "MFA_SETUP")
      return this.Session = e.Session, t.mfaSetup(o, u);
    if (o === "SOFTWARE_TOKEN_MFA")
      return this.Session = e.Session, t.totpRequired(o, u);
    if (o === "CUSTOM_CHALLENGE")
      return this.Session = e.Session, t.customChallenge(u);
    if (o === "NEW_PASSWORD_REQUIRED") {
      this.Session = e.Session;
      var c = null, h = null, f = [], l = n.getNewPasswordRequiredChallengeUserAttributePrefix();
      if (u && (c = JSON.parse(e.ChallengeParameters.userAttributes), h = JSON.parse(e.ChallengeParameters.requiredAttributes)), h)
        for (var v = 0; v < h.length; v++)
          f[v] = h[v].substr(l.length);
      return t.newPasswordRequired(c, f);
    }
    if (o === "DEVICE_SRP_AUTH") {
      this.Session = e.Session, this.getDeviceResponse(t);
      return;
    }
    this.signInUserSession = this.getCognitoUserSession(e.AuthenticationResult), this.challengeName = o, this.cacheTokens();
    var g = e.AuthenticationResult.NewDeviceMetadata;
    if (g == null)
      return t.onSuccess(this.signInUserSession);
    n.generateHashDevice(e.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, e.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(C) {
      if (C)
        return t.onFailure(C);
      var m = {
        Salt: d.Buffer.from(n.getSaltDevices(), "hex").toString("base64"),
        PasswordVerifier: d.Buffer.from(n.getVerifierDevices(), "hex").toString("base64")
      };
      i.verifierDevices = m.PasswordVerifier, i.deviceGroupKey = g.DeviceGroupKey, i.randomPassword = n.getRandomPassword(), i.client.request("ConfirmDevice", {
        DeviceKey: g.DeviceKey,
        AccessToken: i.signInUserSession.getAccessToken().getJwtToken(),
        DeviceSecretVerifierConfig: m,
        DeviceName: $
      }, function(U, A) {
        return U ? t.onFailure(U) : (i.deviceKey = e.AuthenticationResult.NewDeviceMetadata.DeviceKey, i.cacheDeviceKeyAndPassword(), A.UserConfirmationNecessary === !0 ? t.onSuccess(i.signInUserSession, A.UserConfirmationNecessary) : t.onSuccess(i.signInUserSession));
      });
    });
  }, s.completeNewPasswordChallenge = function(e, n, t, i) {
    var o = this;
    if (!e)
      return t.onFailure(new Error("New password is required."));
    var u = new I(this.pool.getUserPoolName()), c = u.getNewPasswordRequiredChallengeUserAttributePrefix(), h = {};
    n && Object.keys(n).forEach(function(l) {
      h[c + l] = n[l];
    }), h.NEW_PASSWORD = e, h.USERNAME = this.username;
    var f = {
      ChallengeName: "NEW_PASSWORD_REQUIRED",
      ClientId: this.pool.getClientId(),
      ChallengeResponses: h,
      Session: this.Session,
      ClientMetadata: i
    };
    this.getUserContextData() && (f.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", f, function(l, v) {
      return l ? t.onFailure(l) : o.authenticateUserInternal(v, u, t);
    });
  }, s.getDeviceResponse = function(e, n) {
    var t = this, i = new I(this.deviceGroupKey), o = new X(), u = {};
    u.USERNAME = this.username, u.DEVICE_KEY = this.deviceKey, i.getLargeAValue(function(c, h) {
      c && e.onFailure(c), u.SRP_A = h.toString(16);
      var f = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: t.pool.getClientId(),
        ChallengeResponses: u,
        ClientMetadata: n,
        Session: t.Session
      };
      t.getUserContextData() && (f.UserContextData = t.getUserContextData()), t.client.request("RespondToAuthChallenge", f, function(l, v) {
        if (l)
          return e.onFailure(l);
        var g = v.ChallengeParameters, C = new S(g.SRP_B, 16), m = new S(g.SALT, 16);
        i.getPasswordAuthenticationKey(t.deviceKey, t.randomPassword, C, m, function(U, A) {
          if (U)
            return e.onFailure(U);
          var F = o.getNowString(), R = d.Buffer.concat([d.Buffer.from(t.deviceGroupKey, "utf8"), d.Buffer.from(t.deviceKey, "utf8"), d.Buffer.from(g.SECRET_BLOCK, "base64"), d.Buffer.from(F, "utf8")]), _ = new E.Sha256(A);
          _.update(R);
          var N = _.digestSync(), O = d.Buffer.from(N).toString("base64"), w = {};
          w.USERNAME = t.username, w.PASSWORD_CLAIM_SECRET_BLOCK = g.SECRET_BLOCK, w.TIMESTAMP = F, w.PASSWORD_CLAIM_SIGNATURE = O, w.DEVICE_KEY = t.deviceKey;
          var p = {
            ChallengeName: "DEVICE_PASSWORD_VERIFIER",
            ClientId: t.pool.getClientId(),
            ChallengeResponses: w,
            Session: v.Session
          };
          t.getUserContextData() && (p.UserContextData = t.getUserContextData()), t.client.request("RespondToAuthChallenge", p, function(T, K) {
            return T ? e.onFailure(T) : (t.signInUserSession = t.getCognitoUserSession(K.AuthenticationResult), t.cacheTokens(), e.onSuccess(t.signInUserSession));
          });
        });
      });
    });
  }, s.confirmRegistration = function(e, n, t, i) {
    var o = {
      ClientId: this.pool.getClientId(),
      ConfirmationCode: e,
      Username: this.username,
      ForceAliasCreation: n,
      ClientMetadata: i
    };
    this.getUserContextData() && (o.UserContextData = this.getUserContextData()), this.client.request("ConfirmSignUp", o, function(u) {
      return u ? t(u, null) : t(null, "SUCCESS");
    });
  }, s.sendCustomChallengeAnswer = function(e, n, t) {
    var i = this, o = {};
    o.USERNAME = this.username, o.ANSWER = e;
    var u = new I(this.pool.getUserPoolName());
    this.getCachedDeviceKeyAndPassword(), this.deviceKey != null && (o.DEVICE_KEY = this.deviceKey);
    var c = {
      ChallengeName: "CUSTOM_CHALLENGE",
      ChallengeResponses: o,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: t
    };
    this.getUserContextData() && (c.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", c, function(h, f) {
      return h ? n.onFailure(h) : i.authenticateUserInternal(f, u, n);
    });
  }, s.sendMFACode = function(e, n, t, i) {
    var o = this, u = {};
    u.USERNAME = this.username, u.SMS_MFA_CODE = e;
    var c = t || "SMS_MFA";
    c === "SOFTWARE_TOKEN_MFA" && (u.SOFTWARE_TOKEN_MFA_CODE = e), this.deviceKey != null && (u.DEVICE_KEY = this.deviceKey);
    var h = {
      ChallengeName: c,
      ChallengeResponses: u,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: i
    };
    this.getUserContextData() && (h.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", h, function(f, l) {
      if (f)
        return n.onFailure(f);
      var v = l.ChallengeName;
      if (v === "DEVICE_SRP_AUTH") {
        o.getDeviceResponse(n);
        return;
      }
      if (o.signInUserSession = o.getCognitoUserSession(l.AuthenticationResult), o.cacheTokens(), l.AuthenticationResult.NewDeviceMetadata == null)
        return n.onSuccess(o.signInUserSession);
      var g = new I(o.pool.getUserPoolName());
      g.generateHashDevice(l.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, l.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(C) {
        if (C)
          return n.onFailure(C);
        var m = {
          Salt: d.Buffer.from(g.getSaltDevices(), "hex").toString("base64"),
          PasswordVerifier: d.Buffer.from(g.getVerifierDevices(), "hex").toString("base64")
        };
        o.verifierDevices = m.PasswordVerifier, o.deviceGroupKey = l.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, o.randomPassword = g.getRandomPassword(), o.client.request("ConfirmDevice", {
          DeviceKey: l.AuthenticationResult.NewDeviceMetadata.DeviceKey,
          AccessToken: o.signInUserSession.getAccessToken().getJwtToken(),
          DeviceSecretVerifierConfig: m,
          DeviceName: $
        }, function(U, A) {
          return U ? n.onFailure(U) : (o.deviceKey = l.AuthenticationResult.NewDeviceMetadata.DeviceKey, o.cacheDeviceKeyAndPassword(), A.UserConfirmationNecessary === !0 ? n.onSuccess(o.signInUserSession, A.UserConfirmationNecessary) : n.onSuccess(o.signInUserSession));
        });
      });
    });
  }, s.changePassword = function(e, n, t, i) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return t(new Error("User is not authenticated"), null);
    this.client.request("ChangePassword", {
      PreviousPassword: e,
      ProposedPassword: n,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: i
    }, function(o) {
      return o ? t(o, null) : t(null, "SUCCESS");
    });
  }, s.enableMFA = function(e) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return e(new Error("User is not authenticated"), null);
    var n = [], t = {
      DeliveryMedium: "SMS",
      AttributeName: "phone_number"
    };
    n.push(t), this.client.request("SetUserSettings", {
      MFAOptions: n,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(i) {
      return i ? e(i, null) : e(null, "SUCCESS");
    });
  }, s.setUserMfaPreference = function(e, n, t) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return t(new Error("User is not authenticated"), null);
    this.client.request("SetUserMFAPreference", {
      SMSMfaSettings: e,
      SoftwareTokenMfaSettings: n,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(i) {
      return i ? t(i, null) : t(null, "SUCCESS");
    });
  }, s.disableMFA = function(e) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return e(new Error("User is not authenticated"), null);
    var n = [];
    this.client.request("SetUserSettings", {
      MFAOptions: n,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(t) {
      return t ? e(t, null) : e(null, "SUCCESS");
    });
  }, s.deleteUser = function(e, n) {
    var t = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return e(new Error("User is not authenticated"), null);
    this.client.request("DeleteUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: n
    }, function(i) {
      return i ? e(i, null) : (t.clearCachedUser(), e(null, "SUCCESS"));
    });
  }, s.updateAttributes = function(e, n, t) {
    var i = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return n(new Error("User is not authenticated"), null);
    this.client.request("UpdateUserAttributes", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserAttributes: e,
      ClientMetadata: t
    }, function(o, u) {
      return o ? n(o, null) : i.getUserData(function() {
        return n(null, "SUCCESS", u);
      }, {
        bypassCache: !0
      });
    });
  }, s.getUserAttributes = function(e) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return e(new Error("User is not authenticated"), null);
    this.client.request("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(n, t) {
      if (n)
        return e(n, null);
      for (var i = [], o = 0; o < t.UserAttributes.length; o++) {
        var u = {
          Name: t.UserAttributes[o].Name,
          Value: t.UserAttributes[o].Value
        }, c = new Q(u);
        i.push(c);
      }
      return e(null, i);
    });
  }, s.getMFAOptions = function(e) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return e(new Error("User is not authenticated"), null);
    this.client.request("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(n, t) {
      return n ? e(n, null) : e(null, t.MFAOptions);
    });
  }, s.createGetUserRequest = function() {
    return this.client.promisifyRequest("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    });
  }, s.refreshSessionIfPossible = function(e) {
    var n = this;
    return e === void 0 && (e = {}), new Promise(function(t) {
      var i = n.signInUserSession.getRefreshToken();
      i && i.getToken() ? n.refreshSession(i, t, e.clientMetadata) : t();
    });
  }, s.getUserData = function(e, n) {
    var t = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return this.clearCachedUserData(), e(new Error("User is not authenticated"), null);
    var i = this.getUserDataFromCache();
    if (!i) {
      this.fetchUserData().then(function(o) {
        e(null, o);
      }).catch(e);
      return;
    }
    if (this.isFetchUserDataAndTokenRequired(n)) {
      this.fetchUserData().then(function(o) {
        return t.refreshSessionIfPossible(n).then(function() {
          return o;
        });
      }).then(function(o) {
        return e(null, o);
      }).catch(e);
      return;
    }
    try {
      e(null, JSON.parse(i));
      return;
    } catch (o) {
      this.clearCachedUserData(), e(o, null);
      return;
    }
  }, s.getUserDataFromCache = function() {
    var e = this.storage.getItem(this.userDataKey);
    return e;
  }, s.isFetchUserDataAndTokenRequired = function(e) {
    var n = e || {}, t = n.bypassCache, i = t === void 0 ? !1 : t;
    return i;
  }, s.fetchUserData = function() {
    var e = this;
    return this.createGetUserRequest().then(function(n) {
      return e.cacheUserData(n), n;
    });
  }, s.deleteAttributes = function(e, n) {
    var t = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return n(new Error("User is not authenticated"), null);
    this.client.request("DeleteUserAttributes", {
      UserAttributeNames: e,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(i) {
      return i ? n(i, null) : t.getUserData(function() {
        return n(null, "SUCCESS");
      }, {
        bypassCache: !0
      });
    });
  }, s.resendConfirmationCode = function(e, n) {
    var t = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: n
    };
    this.client.request("ResendConfirmationCode", t, function(i, o) {
      return i ? e(i, null) : e(null, o);
    });
  }, s.getSession = function(e, n) {
    if (n === void 0 && (n = {}), this.username == null)
      return e(new Error("Username is null. Cannot retrieve a new session"), null);
    if (this.signInUserSession != null && this.signInUserSession.isValid())
      return e(null, this.signInUserSession);
    var t = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, i = t + ".idToken", o = t + ".accessToken", u = t + ".refreshToken", c = t + ".clockDrift";
    if (this.storage.getItem(i)) {
      var h = new b({
        IdToken: this.storage.getItem(i)
      }), f = new G({
        AccessToken: this.storage.getItem(o)
      }), l = new z({
        RefreshToken: this.storage.getItem(u)
      }), v = parseInt(this.storage.getItem(c), 0) || 0, g = {
        IdToken: h,
        AccessToken: f,
        RefreshToken: l,
        ClockDrift: v
      }, C = new Y(g);
      if (C.isValid())
        return this.signInUserSession = C, e(null, this.signInUserSession);
      if (!l.getToken())
        return e(new Error("Cannot retrieve a new session. Please authenticate."), null);
      this.refreshSession(l, e, n.clientMetadata);
    } else
      e(new Error("Local storage is missing an ID Token, Please authenticate"), null);
  }, s.refreshSession = function(e, n, t) {
    var i = this, o = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(n) : n, u = {};
    u.REFRESH_TOKEN = e.getToken();
    var c = "CognitoIdentityServiceProvider." + this.pool.getClientId(), h = c + ".LastAuthUser";
    if (this.storage.getItem(h)) {
      this.username = this.storage.getItem(h);
      var f = c + "." + this.username + ".deviceKey";
      this.deviceKey = this.storage.getItem(f), u.DEVICE_KEY = this.deviceKey;
    }
    var l = {
      ClientId: this.pool.getClientId(),
      AuthFlow: "REFRESH_TOKEN_AUTH",
      AuthParameters: u,
      ClientMetadata: t
    };
    this.getUserContextData() && (l.UserContextData = this.getUserContextData()), this.client.requestWithRetry("InitiateAuth", l, function(v, g) {
      if (v)
        return v.code === "NotAuthorizedException" && i.clearCachedUser(), o(v, null);
      if (g) {
        var C = g.AuthenticationResult;
        return Object.prototype.hasOwnProperty.call(C, "RefreshToken") || (C.RefreshToken = e.getToken()), i.signInUserSession = i.getCognitoUserSession(C), i.cacheTokens(), o(null, i.signInUserSession);
      }
    });
  }, s.cacheTokens = function() {
    var e = "CognitoIdentityServiceProvider." + this.pool.getClientId(), n = e + "." + this.username + ".idToken", t = e + "." + this.username + ".accessToken", i = e + "." + this.username + ".refreshToken", o = e + "." + this.username + ".clockDrift", u = e + ".LastAuthUser";
    this.storage.setItem(n, this.signInUserSession.getIdToken().getJwtToken()), this.storage.setItem(t, this.signInUserSession.getAccessToken().getJwtToken()), this.storage.setItem(i, this.signInUserSession.getRefreshToken().getToken()), this.storage.setItem(o, "" + this.signInUserSession.getClockDrift()), this.storage.setItem(u, this.username);
  }, s.cacheUserData = function(e) {
    this.storage.setItem(this.userDataKey, JSON.stringify(e));
  }, s.clearCachedUserData = function() {
    this.storage.removeItem(this.userDataKey);
  }, s.clearCachedUser = function() {
    this.clearCachedTokens(), this.clearCachedUserData();
  }, s.cacheDeviceKeyAndPassword = function() {
    var e = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, n = e + ".deviceKey", t = e + ".randomPasswordKey", i = e + ".deviceGroupKey";
    this.storage.setItem(n, this.deviceKey), this.storage.setItem(t, this.randomPassword), this.storage.setItem(i, this.deviceGroupKey);
  }, s.getCachedDeviceKeyAndPassword = function() {
    var e = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, n = e + ".deviceKey", t = e + ".randomPasswordKey", i = e + ".deviceGroupKey";
    this.storage.getItem(n) && (this.deviceKey = this.storage.getItem(n), this.randomPassword = this.storage.getItem(t), this.deviceGroupKey = this.storage.getItem(i));
  }, s.clearCachedDeviceKeyAndPassword = function() {
    var e = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, n = e + ".deviceKey", t = e + ".randomPasswordKey", i = e + ".deviceGroupKey";
    this.storage.removeItem(n), this.storage.removeItem(t), this.storage.removeItem(i);
  }, s.clearCachedTokens = function() {
    var e = "CognitoIdentityServiceProvider." + this.pool.getClientId(), n = e + "." + this.username + ".idToken", t = e + "." + this.username + ".accessToken", i = e + "." + this.username + ".refreshToken", o = e + ".LastAuthUser", u = e + "." + this.username + ".clockDrift";
    this.storage.removeItem(n), this.storage.removeItem(t), this.storage.removeItem(i), this.storage.removeItem(o), this.storage.removeItem(u);
  }, s.getCognitoUserSession = function(e) {
    var n = new b(e), t = new G(e), i = new z(e), o = {
      IdToken: n,
      AccessToken: t,
      RefreshToken: i
    };
    return new Y(o);
  }, s.forgotPassword = function(e, n) {
    var t = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: n
    };
    this.getUserContextData() && (t.UserContextData = this.getUserContextData()), this.client.request("ForgotPassword", t, function(i, o) {
      return i ? e.onFailure(i) : typeof e.inputVerificationCode == "function" ? e.inputVerificationCode(o) : e.onSuccess(o);
    });
  }, s.confirmPassword = function(e, n, t, i) {
    var o = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ConfirmationCode: e,
      Password: n,
      ClientMetadata: i
    };
    this.getUserContextData() && (o.UserContextData = this.getUserContextData()), this.client.request("ConfirmForgotPassword", o, function(u) {
      return u ? t.onFailure(u) : t.onSuccess("SUCCESS");
    });
  }, s.getAttributeVerificationCode = function(e, n, t) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return n.onFailure(new Error("User is not authenticated"));
    this.client.request("GetUserAttributeVerificationCode", {
      AttributeName: e,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: t
    }, function(i, o) {
      return i ? n.onFailure(i) : typeof n.inputVerificationCode == "function" ? n.inputVerificationCode(o) : n.onSuccess("SUCCESS");
    });
  }, s.verifyAttribute = function(e, n, t) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return t.onFailure(new Error("User is not authenticated"));
    this.client.request("VerifyUserAttribute", {
      AttributeName: e,
      Code: n,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(i) {
      return i ? t.onFailure(i) : t.onSuccess("SUCCESS");
    });
  }, s.getDevice = function(e) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return e.onFailure(new Error("User is not authenticated"));
    this.client.request("GetDevice", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey
    }, function(n, t) {
      return n ? e.onFailure(n) : e.onSuccess(t);
    });
  }, s.forgetSpecificDevice = function(e, n) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return n.onFailure(new Error("User is not authenticated"));
    this.client.request("ForgetDevice", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: e
    }, function(t) {
      return t ? n.onFailure(t) : n.onSuccess("SUCCESS");
    });
  }, s.forgetDevice = function(e) {
    var n = this;
    this.forgetSpecificDevice(this.deviceKey, {
      onFailure: e.onFailure,
      onSuccess: function(i) {
        return n.deviceKey = null, n.deviceGroupKey = null, n.randomPassword = null, n.clearCachedDeviceKeyAndPassword(), e.onSuccess(i);
      }
    });
  }, s.setDeviceStatusRemembered = function(e) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return e.onFailure(new Error("User is not authenticated"));
    this.client.request("UpdateDeviceStatus", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: "remembered"
    }, function(n) {
      return n ? e.onFailure(n) : e.onSuccess("SUCCESS");
    });
  }, s.setDeviceStatusNotRemembered = function(e) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return e.onFailure(new Error("User is not authenticated"));
    this.client.request("UpdateDeviceStatus", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: "not_remembered"
    }, function(n) {
      return n ? e.onFailure(n) : e.onSuccess("SUCCESS");
    });
  }, s.listDevices = function(e, n, t) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return t.onFailure(new Error("User is not authenticated"));
    var i = {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      Limit: e
    };
    n && (i.PaginationToken = n), this.client.request("ListDevices", i, function(o, u) {
      return o ? t.onFailure(o) : t.onSuccess(u);
    });
  }, s.globalSignOut = function(e) {
    var n = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return e.onFailure(new Error("User is not authenticated"));
    this.client.request("GlobalSignOut", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(t) {
      return t ? e.onFailure(t) : (n.clearCachedUser(), e.onSuccess("SUCCESS"));
    });
  }, s.signOut = function(e) {
    var n = this;
    if (!e || typeof e != "function") {
      this.cleanClientData();
      return;
    }
    this.getSession(function(t, i) {
      if (t)
        return e(t);
      n.revokeTokens(function(o) {
        n.cleanClientData(), e(o);
      });
    });
  }, s.revokeTokens = function(e) {
    if (e === void 0 && (e = function() {
    }), typeof e != "function")
      throw new Error("Invalid revokeTokenCallback. It should be a function.");
    if (!this.signInUserSession) {
      var n = new Error("User is not authenticated");
      return e(n);
    }
    if (!this.signInUserSession.getAccessToken()) {
      var t = new Error("No Access token available");
      return e(t);
    }
    var i = this.signInUserSession.getRefreshToken().getToken(), o = this.signInUserSession.getAccessToken();
    if (this.isSessionRevocable(o) && i)
      return this.revokeToken({
        token: i,
        callback: e
      });
    e();
  }, s.isSessionRevocable = function(e) {
    if (e && typeof e.decodePayload == "function")
      try {
        var n = e.decodePayload(), t = n.origin_jti;
        return !!t;
      } catch {
      }
    return !1;
  }, s.cleanClientData = function() {
    this.signInUserSession = null, this.clearCachedUser();
  }, s.revokeToken = function(e) {
    var n = e.token, t = e.callback;
    this.client.requestWithRetry("RevokeToken", {
      Token: n,
      ClientId: this.pool.getClientId()
    }, function(i) {
      if (i)
        return t(i);
      t();
    });
  }, s.sendMFASelectionAnswer = function(e, n) {
    var t = this, i = {};
    i.USERNAME = this.username, i.ANSWER = e;
    var o = {
      ChallengeName: "SELECT_MFA_TYPE",
      ChallengeResponses: i,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    this.getUserContextData() && (o.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", o, function(u, c) {
      if (u)
        return n.onFailure(u);
      if (t.Session = c.Session, e === "SMS_MFA")
        return n.mfaRequired(c.ChallengeName, c.ChallengeParameters);
      if (e === "SOFTWARE_TOKEN_MFA")
        return n.totpRequired(c.ChallengeName, c.ChallengeParameters);
    });
  }, s.getUserContextData = function() {
    var e = this.pool;
    return e.getUserContextData(this.username);
  }, s.associateSoftwareToken = function(e) {
    var n = this;
    this.signInUserSession != null && this.signInUserSession.isValid() ? this.client.request("AssociateSoftwareToken", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(t, i) {
      return t ? e.onFailure(t) : e.associateSecretCode(i.SecretCode);
    }) : this.client.request("AssociateSoftwareToken", {
      Session: this.Session
    }, function(t, i) {
      return t ? e.onFailure(t) : (n.Session = i.Session, e.associateSecretCode(i.SecretCode));
    });
  }, s.verifySoftwareToken = function(e, n, t) {
    var i = this;
    this.signInUserSession != null && this.signInUserSession.isValid() ? this.client.request("VerifySoftwareToken", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserCode: e,
      FriendlyDeviceName: n
    }, function(o, u) {
      return o ? t.onFailure(o) : t.onSuccess(u);
    }) : this.client.request("VerifySoftwareToken", {
      Session: this.Session,
      UserCode: e,
      FriendlyDeviceName: n
    }, function(o, u) {
      if (o)
        return t.onFailure(o);
      i.Session = u.Session;
      var c = {};
      c.USERNAME = i.username;
      var h = {
        ChallengeName: "MFA_SETUP",
        ClientId: i.pool.getClientId(),
        ChallengeResponses: c,
        Session: i.Session
      };
      i.getUserContextData() && (h.UserContextData = i.getUserContextData()), i.client.request("RespondToAuthChallenge", h, function(f, l) {
        return f ? t.onFailure(f) : (i.signInUserSession = i.getCognitoUserSession(l.AuthenticationResult), i.cacheTokens(), t.onSuccess(i.signInUserSession));
      });
    });
  }, a;
}();
function pe(a, s) {
  a.prototype = Object.create(s.prototype), a.prototype.constructor = a, P(a, s);
}
function j(a) {
  var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return j = function(e) {
    if (e === null || !ye(e)) return e;
    if (typeof e != "function") throw new TypeError("Super expression must either be null or a function");
    if (s !== void 0) {
      if (s.has(e)) return s.get(e);
      s.set(e, n);
    }
    function n() {
      return we(e, arguments, L(this).constructor);
    }
    return n.prototype = Object.create(e.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), P(n, e);
  }, j(a);
}
function we(a, s, r) {
  if (te()) return Reflect.construct.apply(null, arguments);
  var e = [null];
  e.push.apply(e, s);
  var n = new (a.bind.apply(a, e))();
  return r && P(n, r.prototype), n;
}
function te() {
  try {
    var a = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (te = function() {
    return !!a;
  })();
}
function ye(a) {
  try {
    return Function.toString.call(a).indexOf("[native code]") !== -1;
  } catch {
    return typeof a == "function";
  }
}
function P(a, s) {
  return P = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, e) {
    return r.__proto__ = e, r;
  }, P(a, s);
}
function L(a) {
  return L = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(s) {
    return s.__proto__ || Object.getPrototypeOf(s);
  }, L(a);
}
var De = /* @__PURE__ */ function(a) {
  function s(r, e, n, t) {
    var i;
    return i = a.call(this, r) || this, i.code = e, i.name = n, i.statusCode = t, i;
  }
  return pe(s, a), s;
}(/* @__PURE__ */ j(Error)), Ie = /* @__PURE__ */ function() {
  function a(r, e, n) {
    this.endpoint = e || "https://cognito-idp." + r + ".amazonaws.com/";
    var t = n || {}, i = t.credentials;
    this.fetchOptions = i ? {
      credentials: i
    } : {};
  }
  var s = a.prototype;
  return s.promisifyRequest = function(e, n) {
    var t = this;
    return new Promise(function(i, o) {
      t.request(e, n, function(u, c) {
        u ? o(new De(u.message, u.code, u.name, u.statusCode)) : i(c);
      });
    });
  }, s.requestWithRetry = function(e, n, t) {
    var i = this, o = 5 * 1e3;
    Pe(function(u) {
      return new Promise(function(c, h) {
        i.request(e, u, function(f, l) {
          f ? h(f) : c(l);
        });
      });
    }, [n], o).then(function(u) {
      return t(null, u);
    }).catch(function(u) {
      return t(u);
    });
  }, s.request = function(e, n, t) {
    var i = {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService." + e,
      "X-Amz-User-Agent": ue(),
      "Cache-Control": "no-store"
    }, o = Object.assign({}, this.fetchOptions, {
      headers: i,
      method: "POST",
      mode: "cors",
      body: JSON.stringify(n)
    }), u;
    fetch(this.endpoint, o).then(function(c) {
      return u = c, c;
    }, function(c) {
      throw c instanceof TypeError ? new Error("Network error") : c;
    }).then(function(c) {
      return c.json().catch(function() {
        return {};
      });
    }).then(function(c) {
      if (u.ok) return t(null, c);
      var h = (c.__type || c.code).split("#").pop(), f = new Error(c.message || c.Message || null);
      return f.name = h, f.code = h, t(f);
    }).catch(function(c) {
      if (u && u.headers && u.headers.get("x-amzn-errortype"))
        try {
          var h = u.headers.get("x-amzn-errortype").split(":")[0], f = new Error(u.status ? u.status.toString() : null);
          return f.code = h, f.name = h, f.statusCode = u.status, t(f);
        } catch {
          return t(c);
        }
      else c instanceof Error && c.message === "Network error" && (c.code = "NetworkError");
      return t(c);
    });
  }, a;
}(), k = {
  debug: function() {
  }
}, Te = function(s) {
  var r = "nonRetryable";
  return s && s[r];
};
function ne(a, s, r, e) {
  if (e === void 0 && (e = 1), typeof a != "function")
    throw Error("functionToRetry must be a function");
  return k.debug(a.name + " attempt #" + e + " with args: " + JSON.stringify(s)), a.apply(void 0, s).catch(function(n) {
    if (k.debug("error on " + a.name, n), Te(n))
      throw k.debug(a.name + " non retryable error", n), n;
    var t = r(e, s, n);
    if (k.debug(a.name + " retrying in " + t + " ms"), t !== !1)
      return new Promise(function(i) {
        return setTimeout(i, t);
      }).then(function() {
        return ne(a, s, r, e + 1);
      });
    throw n;
  });
}
function Ee(a) {
  var s = 100, r = 100;
  return function(e) {
    var n = Math.pow(2, e) * s + r * Math.random();
    return n > a ? !1 : n;
  };
}
function Pe(a, s, r) {
  return ne(a, s, Ee(r));
}
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Fe = 55, Re = /* @__PURE__ */ function() {
  function a(r, e) {
    var n = r || {}, t = n.UserPoolId, i = n.ClientId, o = n.endpoint, u = n.fetchOptions, c = n.AdvancedSecurityDataCollectionFlag;
    if (!t || !i)
      throw new Error("Both UserPoolId and ClientId are required.");
    if (t.length > Fe || !/^[\w-]+_[0-9a-zA-Z]+$/.test(t))
      throw new Error("Invalid UserPoolId format.");
    var h = t.split("_")[0];
    this.userPoolId = t, this.clientId = i, this.client = new Ie(h, o, u), this.advancedSecurityDataCollectionFlag = c !== !1, this.storage = r.Storage || new ee().getStorage(), e && (this.wrapRefreshSessionCallback = e);
  }
  var s = a.prototype;
  return s.getUserPoolId = function() {
    return this.userPoolId;
  }, s.getUserPoolName = function() {
    return this.getUserPoolId().split("_")[1];
  }, s.getClientId = function() {
    return this.clientId;
  }, s.signUp = function(e, n, t, i, o, u) {
    var c = this, h = {
      ClientId: this.clientId,
      Username: e,
      Password: n,
      UserAttributes: t,
      ValidationData: i,
      ClientMetadata: u
    };
    this.getUserContextData(e) && (h.UserContextData = this.getUserContextData(e)), this.client.request("SignUp", h, function(f, l) {
      if (f)
        return o(f, null);
      var v = {
        Username: e,
        Pool: c,
        Storage: c.storage
      }, g = {
        user: new D(v),
        userConfirmed: l.UserConfirmed,
        userSub: l.UserSub,
        codeDeliveryDetails: l.CodeDeliveryDetails
      };
      return o(null, g);
    });
  }, s.getCurrentUser = function() {
    var e = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser", n = this.storage.getItem(e);
    if (n) {
      var t = {
        Username: n,
        Pool: this,
        Storage: this.storage
      };
      return new D(t);
    }
    return null;
  }, s.getUserContextData = function(e) {
    if (!(typeof AmazonCognitoAdvancedSecurityData > "u")) {
      var n = AmazonCognitoAdvancedSecurityData;
      if (this.advancedSecurityDataCollectionFlag) {
        var t = n.getData(e, this.userPoolId, this.clientId);
        if (t) {
          var i = {
            EncodedData: t
          };
          return i;
        }
      }
      return {};
    }
  }, a;
}();
class Ke {
  constructor(s) {
    J(this, "userPool");
    this.userPool = new Re(s);
  }
  getUserSession(s) {
    return new Promise((r, e) => {
      s.getSession((n, t) => {
        n || !t ? e(n) : r(t);
      });
    });
  }
  async getUserAttributes(s) {
    const r = await new Promise(
      (n, t) => s.getUserAttributes((i, o) => {
        i ? t(i) : n(o);
      })
    );
    return Object.fromEntries(
      (r == null ? void 0 : r.map((n) => [n.getName(), n.getValue()])) ?? []
    );
  }
  async initialize() {
    const s = this.userPool.getCurrentUser();
    if (!s)
      throw new Error("No user found");
    const r = await this.getUserSession(s), e = await this.getUserAttributes(s);
    return { user: s, session: r, userAttributes: e };
  }
  async signIn(s) {
    const r = new D({
      Username: s.username,
      Pool: this.userPool
    }), e = await new Promise(
      (t, i) => r.authenticateUser(
        new ce({
          Username: s.username,
          Password: s.password
        }),
        {
          onSuccess: t,
          onFailure: i
        }
      )
    ), n = await this.getUserAttributes(r);
    return {
      user: r,
      session: e,
      userAttributes: n
    };
  }
  signOut() {
    const s = this.userPool.getCurrentUser();
    return s == null || s.signOut(), null;
  }
  async refreshToken() {
    const s = this.userPool.getCurrentUser();
    if (!s)
      throw new Error("No user found");
    const e = (await this.getUserSession(s)).getRefreshToken(), n = await this.getUserAttributes(s);
    return new Promise((t, i) => {
      s.refreshSession(
        e,
        (o, u) => {
          if (o)
            return i(o);
          t({
            user: s,
            session: u,
            userAttributes: n
          });
        }
      );
    });
  }
  async signUp(s) {
    return await new Promise(
      (e, n) => this.userPool.signUp(
        s.username,
        s.password,
        [],
        [],
        (t, i) => {
          if (t)
            return n(t);
          if (!i)
            return n(new Error("No result"));
          e(i);
        }
      )
    );
  }
  async resendSignUp(s) {
    const r = new D({
      Username: s,
      Pool: this.userPool
    });
    await new Promise(
      (e, n) => r.resendConfirmationCode((t, i) => {
        if (t)
          return n(t);
        e(i);
      })
    );
  }
  async confirmSignUp(s, r) {
    const e = new D({
      Username: s,
      Pool: this.userPool
    });
    await new Promise(
      (n, t) => e.confirmRegistration(r, !0, (i, o) => {
        if (i)
          return t(i);
        n(o);
      })
    );
  }
  async updateUserAttributes(s) {
    const r = this.userPool.getCurrentUser();
    if (!r)
      throw new Error("No user found");
    await this.getUserSession(r);
    const e = Object.entries(s).map(
      ([n, t]) => new Q({ Name: n, Value: t })
    );
    await new Promise(
      (n, t) => r.updateAttributes(e, (i, o) => {
        if (i)
          return t(i);
        n(o);
      })
    );
  }
  async forgotPassword(s) {
    const r = new D({
      Username: s,
      Pool: this.userPool
    });
    await new Promise(
      (e, n) => r.forgotPassword({
        onSuccess: e,
        onFailure: n
      })
    );
  }
  async forgotPasswordSubmit(s, r, e) {
    const n = new D({
      Username: s,
      Pool: this.userPool
    });
    await new Promise(
      (t, i) => n.confirmPassword(r, e, {
        onSuccess: t,
        onFailure: i
      })
    );
  }
  async verifyUserAttributeSubmit(s, r) {
    const e = this.userPool.getCurrentUser();
    if (!e)
      throw new Error("No user found");
    try {
      await this.getUserSession(e), await new Promise(
        (n, t) => e.verifyAttribute(s, r, {
          onSuccess: n,
          onFailure: t
        })
      );
    } catch (n) {
      throw console.error("Error verifying user attribute:", n), n;
    }
  }
  async verifyUserAttribute(s, r) {
    const e = this.userPool.getCurrentUser();
    if (!e)
      throw new Error("No user found");
    await this.getUserSession(e), await new Promise(
      (n, t) => e.getAttributeVerificationCode(
        s,
        {
          onSuccess: n,
          onFailure: t
        },
        r
      )
    );
  }
}
export {
  Ke as Auth
};
